(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/board-buttons.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/board-buttons.js');

'use strict';

svs.numbergames.game.views.BoardButtons = Marionette.View.extend({
  className() {
    const brandingSuffix = svs.numbergames.productMapping.getBrandingClass(this.options.productId);
    return "numbergames-board-buttons numbergames-board-buttons-".concat(brandingSuffix, " padding-top-1");
  },
  ui: {
    resetBtn: '.js-reset-board-btn',
    huxfluxBtn: '.js-huxflux-board-btn',
    newBtn: '.js-new-board-btn',
    huxfluxExtraBtn: '.js-huxflux-extra-board-btn'
  },
  triggers: {
    'click @ui.resetBtn': 'clearBoard',
    'click @ui.huxfluxBtn': 'huxfluxBoard',
    'click @ui.huxfluxExtraBtn': 'huxfluxExtraBoards',
    'click @ui.newBtn': 'newBoard'
  },
  modelEvents: {
    'change:isValid': 'changeValid',
    'change:isEmpty': 'changeEmpty',
    'change:isActive': 'changeModel'
  },
  collectionEvents: {
    'change:isEmpty': 'checkExtraBoardButtons'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
    channel: svs.numbergames.game.huxfluxRadio
  }, svs.numbergames.accessibility.behaviors.UIFocusDisable 
  ],
  radioEvents: {
    'huxflux:start': 'huxfluxStarted',
    'huxflux:end': 'huxfluxEnded'
  },
  template(data) {
    return svs.numbergames.game.templates.board_buttons(data);
  },
  templateContext() {
    var _svs$numbergames$game;
    let {
      multiHuxFluxArray = []
    } = (_svs$numbergames$game = svs.numbergames.game.view_options[this.options.productId]) !== null && _svs$numbergames$game !== void 0 ? _svs$numbergames$game : {};
    multiHuxFluxArray = multiHuxFluxArray.map(n => ({
      title: "+".concat(n, " Rad").concat(n > 1 ? 'er' : ''),
      numberOfRows: n
    }));
    return {
      resetBtnTitle: this.collection.noEmptyBoards ? 'Ta bort' : 'Rensa',
      invertedButton: !svs.numbergames.productMapping.isKeno(this.options.productId) && !svs.numbergames.productMapping.isEurojackpot(this.options.productId),
      transparentButton: !svs.numbergames.productMapping.isEurojackpot(this.options.productId),
      multiHuxFluxArray
    };
  },
  initialize() {
    this.maxNumberOfRows = this.collection.rules.maxNumberOfRows;
    this.remainingExtraBoardsToBeHuxfluxed = 0;
  },
  onRender() {
    this.changeModel(this.collection.getActive());
    this.checkExtraBoardButtons();
  },
  checkExtraBoardButtons() {
    if (this.remainingExtraBoardsToBeHuxfluxed > 0) {
      return;
    }
    const empty = this.maxNumberOfRows - this.collection.length + this.collection.getNumberOfEmptyInactiveBoards();
    this.getUI('huxfluxExtraBtn').each((index, el) => {
      const $el = $(el);
      const boards = parseInt($el.attr('data-boards'), 10);
      this.trigger('toggleUI', $el, boards > empty);
    });
  },
  onHuxfluxExtraBoards(el, ev) {
    const count = parseInt(ev.currentTarget.dataset.boards, 10);
    const level = this.model.get('level');
    const hasKungKeno = this.model.get('hasKungKeno');
    const emptyBoardsArray = this.collection.getEmptyInactiveBoards();
    const boardsToAdd = count - emptyBoardsArray.length + this.collection.length;
    const canAddBoards = boardsToAdd <= this.maxNumberOfRows;
    if (!canAddBoards) {
      svs.numbergames.game.logger.info('Unable to add boards. This may be caused by invalid number of boards');
      return;
    }
    if (emptyBoardsArray.length < count) {
      const result = this.collection.add(count - emptyBoardsArray.length);
      emptyBoardsArray.push(...result);
    }
    this.remainingExtraBoardsToBeHuxfluxed = count;
    for (let i = 0; i < count; i++) {
      if (level) {
        emptyBoardsArray[i].set({
          level,
          hasKungKeno
        });
      }
      this.radio.trigger('huxflux:start', emptyBoardsArray[i]);
    }
    this.trackBoardBtn("+".concat(count));
  },
  changeModel() {
    if (this.model) this.unbindEvents(this.model, this.modelEvents);
    this.model = this.collection.getActive();
    this.bindEvents(this.collection.getActive(), this.modelEvents);
    this.changeEmpty();
    this.changeValid();
    this.checkExtraBoardButtons();
  },
  onClearBoard(view, event) {
    this.trackBoardBtn('ta_bort');
    svs.numbergames.game.logger.debug('views.BoardButtons clearBoard', event);
    this.collection.clearActive();
    this.changeModel(this.collection.getActive());
    this.changeValid();
  },
  onHuxfluxBoard(view, event) {
    this.trackBoardBtn('huxflux');
    svs.numbergames.game.logger.debug('views.BoardButtons huxfluxBoard', event);
    this.radio.trigger('huxflux:start', this.model);
  },
  onNewBoard(view, event) {
    this.trackBoardBtn('ny_rad');
    svs.numbergames.game.logger.debug('views.BoardButtons newBoard', event);
    this.collection.activateNext();
    this.changeModel(this.collection.getActive());
  },
  changeValid() {
    const isValid = this.model.get('isValid');
    const validBoards = this.collection.getNumberOfValidBoards();
    const canAddBoard = isValid && validBoards < this.maxNumberOfRows;
    const canHuxfluxBoard = this.model.canHuxflux();
    this.trigger('toggleUI', this.getUI('newBtn'), !canAddBoard);
    this.trigger('toggleUI', this.getUI('huxfluxBtn'), !canHuxfluxBoard);
  },
  changeEmpty() {
    let canClearBoard = !this.model.get('isEmpty');
    if (canClearBoard && this.collection.noEmptyBoards) {
      canClearBoard = this.collection.getNumberOfValidBoards() > 1;
    }
    this.trigger('toggleUI', this.getUI('resetBtn'), !canClearBoard);
  },
  huxfluxStarted() {
    this.trigger('disableUI', this.getUI('huxfluxBtn'));
    this.trigger('disableUI', this.getUI('resetBtn'));
    this.trigger('disableUI', this.getUI('newBtn'));
    this.trigger('disableUI', this.getUI('huxfluxExtraBtn'));
  },
  huxfluxEnded() {
    this.remainingExtraBoardsToBeHuxfluxed = Math.max(this.remainingExtraBoardsToBeHuxfluxed - 1, 0);
    this.changeValid();
    this.changeEmpty();
    this.checkExtraBoardButtons();
  },
  trackBoardBtn(eventName) {
    svs.components.analytics.trackEvent({
      category: "".concat(svs.numbergames.productMapping.getProductName(this.model.get('productId')), " Page"),
      action: eventName,
      opt_label: 'click buttons'
    });
  }
});

 })(window);